
import Vue from 'vue'
import config from '../appConfig';

Vue.filter('imgPath', (img) => {
    return config.imgUrl + img;
});